import axios from "axios";

let getServerCookieUrl = `${process.env.VUE_APP_API_URL}/gzbn-auth/auth/getGzbnCookieId`;
let dailyOutRecordUrl = `${process.env.VUE_APP_API_URL}/plus-cloud-interact-app/app/dailyOutRecord/save`;

function get(url, params) {
  const obj = Object.assign({}, params);
  obj.cookieId = getBrowserCookie("gzbn_cookie_id");

  return new Promise((resolve, reject) => {
    axios
      .get(
        url,
        {
          params: obj,
          withCredentials: true,
        },
        { withCredentials: true }
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function post(url, params) {
  const obj = Object.assign({}, params);
  obj.cookieId = getBrowserCookie("gzbn_cookie_id");
  return new Promise((resolve, reject) => {
    axios
      .post(url, obj, {
        withCredentials: true,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

function getServerCookie(params) {
  return get(getServerCookieUrl, params)
    .then((res) => res)
    .catch((e) => e);
}

function dailyOutRecord(params) {
  return post(dailyOutRecordUrl, params)
    .then((res) => res)
    .catch((e) => e);
}

function getBrowserCookie(name) {
  var cookieArr = document.cookie.split("; ");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");
    if (cookiePair[0] === name) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

function gzbnDailyInit() {
  if (!getBrowserCookie("gzbn_cookie_id")) {
    getServerCookie().then(() => {
      dailyOutRecord({ tenantCode: "hcplus" });
    });
  } else {
    dailyOutRecord({ tenantCode: "hcplus" });
  }
  // const open = XMLHttpRequest.prototype.open;
  // XMLHttpRequest.prototype.open = function (method, url) {
  //   if (!getBrowserCookie("gzbn_cookie_id") && url != getServerCookieUrl && url != dailyOutRecordUrl) {
  //     getServerCookie().then(() => {
  //       dailyOutRecord({ tenantCode: "hcplus" });
  //     });
  //   }

  //   return open.apply(this, arguments);
  // };
}

gzbnDailyInit();
